import NotificationError from 'components/common/notificationsErrors'
import { FormRefsContext } from 'context/FormRefsContext'
import { Form, Formik } from 'formik'
import { getInitValues, getValidationSchema } from 'lib/FieldValidations'
import { IProductAttributesGlobalUploadModalFormProps } from 'models/ProductGlobalUploadInterface'
import React, { Component, Fragment } from 'react'
import { Button, Col, Row } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'
import { withRouter } from 'react-router-dom'
import _ from 'underscore'
import ProductAttributesGLobalModalFormField from './ProductAttributesGlobalModalFormFields'

class ProductAttributesGlobalModalForm extends Component<IProductAttributesGlobalUploadModalFormProps> {
	handleMapValues = (values: any) => {
		const { handleSubmit, fields } = this.props
		const lista: any = []
		if (fields.length > 0) {
			fields
				.filter((field) => field.agrupador === 'atributo')
				.forEach((field) => {
					lista.push({
						codigo: field.idCampo,
						valor: values[field.idCampo]
					})
				})
		}
		const apiPayload = { niprod: values.niprod, lista: lista }

		handleSubmit(apiPayload)
	}

	render() {
		const {
			itemInfo,
			t,
			handleCloseEditPopup,
			fields,
			productAttributesGlobalUploadModalFields
		} = this.props

		const initialValues =
			itemInfo || (fields.length ? getInitValues(fields) : {}) // valores iniciales tomados de la API de campos

		const validationSchema = fields.length
			? getValidationSchema(fields, t, [], [])
			: {}

		return (
			<FormRefsContext.Consumer>
				{({ formRef, cancelButtonRef }) => (
					<Formik
						ref={formRef}
						initialValues={initialValues}
						onSubmit={(values, actions) => {
							this.handleMapValues(values)
						}}
						enableReinitialize={true}
						validationSchema={validationSchema}
					>
						{(props) => (
							<Fragment>
								<Col sm={12}>
									<NotificationError
										errors={props.errors}
										touched={props.touched}
									/>
								</Col>
								<Form>
									<Row>
										{_.map(fields, (field) => {
											return (
												<ProductAttributesGLobalModalFormField
													key={field.idCampo}
													formikProps={props}
													field={field}
													crudProps={{
														...this.props
													}}
													initialValue={
														initialValues[
															field.idCampo as keyof typeof initialValues
														]
													}
													productAttributesGlobalUploadModalFields={
														productAttributesGlobalUploadModalFields
													}
												/>
											)
										})}
									</Row>
									<Row className="justify-content-center text-center">
										<Button
											style={{ minWidth: '145px', margin: '20px' }}
											type={'submit'}
										>
											{t('Collection.form.buttons.accept')}
										</Button>

										<Button
											style={{ minWidth: '145px', margin: '20px' }}
											type={'button'}
											onClick={handleCloseEditPopup}
										>
											{t('global.cancel')}
										</Button>
									</Row>
								</Form>
							</Fragment>
						)}
					</Formik>
				)}
			</FormRefsContext.Consumer>
		)
	}
}

export default withTranslation()(withRouter(ProductAttributesGlobalModalForm))
